export const Options = {
  color: '#F4C900',
  failedColor: '#FF3939',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}



// WEBPACK FOOTER //
// ./src/progress-bar-options.js